import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppService } from '../../../../app.service';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CtwrRequestService } from '../../ctwr.service';
import { RequestDetailService } from './detail.service';
import { PrimaryPartGrid } from './primary-part.template';
import { ImpactedPartGrid } from './impacted-part.template';
import { ApprovalStatus } from '../../workflow.service';
import { PartApprovalMatrix } from './part-approval-matrix/part-approval-matrix.component';
import { PanelbarService } from '../../../../shared/expandable-panelbar/expandable-panelbar.service';
import { FileInfo, FileState } from '@progress/kendo-angular-upload';
import { S3Service } from '../../../../shared/services/s3.service';
import { WorkApprovalMatrix } from './work-approval-matrix/work-approval-matrix.component';
import { RequestHistoryGrid } from './request-history.template'
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { PartApprovalMatrixPrintView } from './part-approval-matrix-print-view';
import { LocationApprovalMatrixPrintView } from './location-approval-matrix-print-view';
import { RequestHistoryPrintView } from './request-history-print-view';
import { CommentDialogTemplate } from './comment-dialog.template';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';

import { DetailStepperTemplate } from './detail-stepper.template';
import { takeUntil } from 'rxjs/operators';

const DETAIL_ROUTE = '/Detail?requestId=';


@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})


export class DetailComponent implements OnInit {
  /**
   * 
   */
  request: any = {};
  /**
   * 
   */
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  /**
   * 
   */
  stepper: DetailStepperTemplate;
  /**
   * 
   */
  primaryPartGrid: PrimaryPartGrid;
  /**
   * 
   */
  impactedPartGrid: ImpactedPartGrid;
  /**
   * 
   */
  partApprovalMatrix: PartApprovalMatrix = new PartApprovalMatrix(this.injector);
  /**
   * 
   */
  workApprovalMatrix: WorkApprovalMatrix = new WorkApprovalMatrix(this.injector);
  /**
   * 
   */
  commentFile: any;
  /**
   * 
   */
  commentDialog: CommentDialogTemplate = new CommentDialogTemplate(this.injector);
  /**
   * 
   */
  requestHistoryGrid: RequestHistoryGrid;
  /**
   * 
   */
  partApprovalMatrixPrintView: PartApprovalMatrixPrintView;
  /**
   * 
   */
  locationApprovalMatrixPrintView: LocationApprovalMatrixPrintView;
  /**
   * 
   */
  requestHistoryPrintView: RequestHistoryPrintView;
  /**
   * 
   */
  printFormDialog: FormDialogTemplate;
  /**
   * 
   */
  temporaryRequests: string[] = [];

  workApprovals: any;
  isPteTm: boolean;
  printFormOpen = true;
  printEditForm: FormGroup;
  printFormControls: any[] = [{
    type: 'textarea',
    title: 'Comments',
    name: 'Comments',
    stretch: true,
  }];
  printFormTabs = [
    {
      title: "Users",
      selected: true,
      formControls: this.printFormControls,
    },
  ]
  /*
  * for Print/Export 
  */
  primaryParts: any;
  impactedParts = [];
  partApprovals = [];
  partApprovalGridData = [];
  locationApprovals = [];
  locationApprovalGridData = [];
  toolingParts = [];
  workApprovalGridData = [];
  history = [];
  private readonly route: ActivatedRoute;
  private readonly appService: AppService;
  private readonly ctwrRequestService: CtwrRequestService;
  private readonly printFormBuilder: FormBuilder;
  private readonly confirmationDialog: CgpConfirmationDialogService;
  private readonly cgpSnackbar: CgpSnackbarService;
  private readonly s3Service: S3Service;
  private readonly router: Router;
  private readonly detailService: RequestDetailService;
  public readonly panelbarService: PanelbarService;

  constructor(private readonly injector: Injector) {
    this.printFormDialog = new FormDialogTemplate();
    this.printFormDialog.setHeight(640);
    this.printFormDialog.cancel = () => this.closeForm;
    this.route = injector.get(ActivatedRoute);
    this.appService = injector.get(AppService);
    this.ctwrRequestService = injector.get(CtwrRequestService);
    this.printFormBuilder = injector.get(FormBuilder);
    this.confirmationDialog = injector.get(CgpConfirmationDialogService);
    this.cgpSnackbar = injector.get(CgpSnackbarService);
    this.s3Service = injector.get(S3Service);
    this.router = injector.get(Router);
    this.detailService = injector.get(RequestDetailService);
    this.panelbarService = injector.get(PanelbarService);
    this.printFormDialog.initilize("Select printing part", this.printEditForm, this.printFormTabs);
    this.printFormDialog.cancel = this.PrintClose;
    this.printFormDialog.notificationLabel = { flag: 'info', value: '*You must select at least 1 item for a component.' };
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.initializeComponents();
    this.printEditForm = this.printFormBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
    })
    this.stepper.addStep(RequestSteps);
    this.detailService.reset();
    this.partApprovalMatrix.reset();
    this.workApprovalMatrix.reset();
    this.isPteTm = this.detailService.isPteTm;
    this.registerComponents();
  }

  private initializeComponents() {
    this.stepper = new DetailStepperTemplate(this.detailService);
    this.primaryPartGrid = new PrimaryPartGrid(this.detailService);
    this.impactedPartGrid = new ImpactedPartGrid(this.detailService);
    this.requestHistoryGrid = new RequestHistoryGrid(this.detailService);
    this.partApprovalMatrixPrintView = new PartApprovalMatrixPrintView(this.detailService);
    this.locationApprovalMatrixPrintView = new LocationApprovalMatrixPrintView(this.detailService);
    this.requestHistoryPrintView = new RequestHistoryPrintView(this.detailService);
  }

  /**
   * 
   */
  private registerComponents() {
    this.registerParamMap();
    this.registerDetailService();
    this.registerPartApproval();
    this.registerWorkApproval();
    this.registerHistory();
  }

  /**
   * 
   */
  private registerParamMap() {
    this.route.paramMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: any) => {
        if (x && x.params && x.params.id) {
          this.detailService.RequestNumber = x.params.id;
          this.detailService.refreshRequest();
        }
      });
  }

  /**
   * 
   */
  private registerDetailService() {
    this.detailService.requestDetail
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(x => {
        if (x) {
          if (this.partApprovals.length < 1) {
            this.detailService.refreshPartApprovalMatrix();
            this.detailService.refreshWorkApprovalMatrix();
          }
          this.setTemporaryRequests();
          if (x.RequestAttachmentDtos) x.RequestAttachmentDtos = this.mapRequestAttachmentDto(x.RequestAttachmentDtos);
          this.request = x;
          const _title = `Detail - Request# ${x.RequestNumber}`;
          this.appService.viewTitle = _title;
        } else {
          this.request = {};
        }
      });
  }

  /**
   * 
   */
  private registerPartApproval() {
    this.detailService.partApprovalData
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(x => {
        if (x && x.PartApprovals && x.LocationApprovals) {
          this.partApprovals = [];
          this.locationApprovals = [];
          x.PartApprovals.forEach(pa => {
            this.partApprovalGridData = [];
            pa.PartApprovalDetails.forEach(d => {
              this.partApprovalGridData.push({
                'PTE': d.PTEName,
                'Status': d.Status,
                'IsLibraryImpact': d.LibImapctDetail.IsLibImpact,
                'ReviewDate': d.ReviewDate
              });
            });
            this.partApprovals.push({ 'PA': pa.PartApprovalTitle, 'Data': this.partApprovalGridData });
          });
          this.locationApprovals = [];
          x.LocationApprovals.forEach(la => {
            this.locationApprovals.push({
              'Title': la.Title,
              'TM': la.TMName,
              'Status': la.Status,
              'ApprovalDate': la.ApprovalDate
            });
          });
        }
      });
  }

  /**
   * 
   */
  private registerWorkApproval() {
    this.detailService.workApprovalData
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(x => {
        if (x && x.ToolingParts && x.ToolingParts.length) {
          this.workApprovals = x.ToolingParts;
          this.toolingParts = [];
          x.ToolingParts.forEach(tp => {
            let _attachments: any[];
            this.workApprovalGridData = [];
            tp.ToolingComponentCategories.forEach(cc => {
              cc.Components.forEach(component => {
                component.ToolingItems.forEach(ti => {
                  this.workApprovalGridData.push({
                    'Category': cc.CategoryName,
                    'Component': component.ComponentName,
                    'Item': ti.ItemName,
                    'Status': ti.Status,
                    'PTE': ti.AssignedPTEName,
                    'ECONumber': ti.ECONumber,
                    'IsLibraryImpact': ti.IsLibPartImapcted,
                    'PTECompletion': ti.PTECompletionDate,
                    'DES': ti.AssignedDESName,
                    'DESCompletion': ti.DESCompletionDate,
                  });
                });
                _attachments = component.Attachments;
                if (_attachments && _attachments.length) this.workApprovalGridData.push(_attachments);
              });
            });
            this.toolingParts.push({
              'TP': tp.PartTitle,
              'Data': this.workApprovalGridData,
            });
          });
        }
      });
  }

  /**
   * 
   */
  private registerHistory() {
    this.detailService.history
      .subscribe(x => {
        if (x) {
          this.history = [];
          x.forEach(history => {
            this.history.push({
              'User': history.Actor,
              'Description': history.Description,
              'Action': history.Action,
              'Date': history.Date
            })
          });
        }
      });
  }


  /**
   * 
   * @param files 
   */
  private mapRequestAttachmentDto(files: any[]): FileInfo[] {
    if (!files) return null;
    return files
      .map(i => {
        return {
          name: i.FileName,
          CreatedBy: i.CreatedBy,
          CreatedDate: i.CreatedDate,
          uid: i.Id,
          state: FileState.Uploaded,
          comment: i.FileDescription
        } as FileInfo;
      });
  }


  /**
   * 
   */
  download = (file: any) => this.s3Service.downloadS3Object(file, `CTWR/${this.request.RequestNumber}/`);


  /**
   * 
   */
  printOpen() {
    this.printFormOpen = true;
    return this.printFormDialog
  }


  /**
   * 
   * @param status 
   */
  PrintClose(status) {
    console.log(`Dialog result: ${status}`);
    this.printFormOpen = false;
  }


  /**
   * 
   */
  closeForm() { }


  /**
   * 
   */
  onRequestCancel = () => {
    this.panelbarService.formDialog.next(this.commentDialog);
    this.commentDialog.title.next('Request Cancellation');
    this.commentDialog.next({});
    this.commentDialog.submitText = 'Submit';
    this.commentDialog.save = ({ dataItem }) => {
      this.ctwrRequestService.save(dataItem.comment, false, `/CancelRequest?requestId=${this.request.RequestId}`)
        .then(x => this.detailService.refreshRequest());
    }
  }

  /**
   * 
   */
  onRequestRework = () => {
    this.panelbarService.formDialog.next(this.commentDialog);
    this.commentDialog.title.next('Edit Request');
    this.commentDialog.next({});
    this.commentDialog.submitText = 'Submit';
    this.commentDialog.save = ({ dataItem }) => {
      this.ctwrRequestService.save(dataItem.comment, false, `/ReworkRequest?requestId=${this.request.RequestId}`)
        .then(x => this.detailService.refreshRequest());
    }
  }


  /**
   * 
   */
  handleRequestCopy = () => {
    const dataItem = this.request;
    this.confirmationDialog.showConfirmationDialog({
      title: 'Request Copy Confirmation',
      message: `Are you sure you want to copy Request# ${dataItem.RequestNumber}?`,
      alert: 'warning',
      onYesClick: () => {
        this.confirmationDialog.closeConfirmationDialog();
        this.ctwrRequestService.save({}, false, `/CopyRequest?requestId=${dataItem.RequestId}`)
          .then(x => {
            this.displaySnackbar(`Copy Sucessful. See ${x.RequestNumber} in the Request Inbox.`);
            this.handleS3Copy(dataItem, x);
          });

      },
      onNoClick: () => {
        this.confirmationDialog.closeConfirmationDialog();
      }
    });
  }


  /**
   * 
   * @param request - Request copy response
   */
  private handleS3Copy(request: any, requestCopy: any) {
    this.ctwrRequestService.read(`${DETAIL_ROUTE}${requestCopy.RequestId}`)
      .then(copy => {
        if (!copy.RequestAttachmentDtos) return;
        const _sourcePath = `CTWR/${request.RequestNumber}/`;
        const _destinationPath = `CTWR/${requestCopy.RequestNumber}/`;
        const _files: FileInfo[] = copy.RequestAttachmentDtos
          .map(f => { return { name: f.FileName, state: FileState.Initial } as FileInfo; });
        this.s3Service.handleS3Copy(_files, _sourcePath, _destinationPath)
          .catch(e => {
            if (e.status !== 200) this.deleteAllRequestAttachments(copy);
            this.ctwrRequestService.handleError(e);
          });
      });
  }



  /**
   * Remove attachments for request
   */
  deleteAllRequestAttachments(dataItem: any) {
    if (!dataItem) return;
    const _path = '/RequestAttachment?requestAttachmentIds=';
    const files: any[] = dataItem.RequestAttachmentDtos;

    if (files) {
      files.forEach(f => {
        const id = f.Id;
        if (id) this.ctwrRequestService.remove(`${_path}${id}&RequestId=${dataItem.RequestId}`);
      })
    } else {
      this.ctwrRequestService.read(`/Detail/ByRequestNumber?requestNumber=${dataItem.RequestNumber}&isRefresh=false`)
        .then(x => this.deleteAllRequestAttachments(x));
    }
  }



  /**
   * 
   */
  handleHold = () => {
    let _call = 'RemoveOnHold';
    if (this.isOnHold()) {
      this.confirmationDialog.showConfirmationDialog({
        title: 'Remove Hold Confirmation',
        message: `Are you sure you want to remove the hold on Request# ${this.request.RequestNumber}?`,
        alert: 'warning',
        onYesClick: () => {
          this.confirmationDialog.closeConfirmationDialog();
          this.ctwrRequestService
            .save({}, false, `/${_call}?requestId=${this.request.RequestId}`)
            .then(x => {
              this.detailService.refreshPartApprovalMatrix();
              this.detailService.refreshWorkApprovalMatrix();
            });
        },
        onNoClick: () => {
          this.confirmationDialog.closeConfirmationDialog();
        }
      });
    } else {
      _call = 'SetOnHold';
      this.panelbarService.formDialog.next(this.commentDialog);
      this.commentDialog.title.next('Hold Request Confirmation');
      this.commentDialog.next({});
      this.commentDialog.submitText = 'Submit';
      this.commentDialog.save = ({ dataItem }) => {
        this.ctwrRequestService
          .save(dataItem.comment, false, `/${_call}?requestId=${this.request.RequestId}`)
          .then(x => {
            this.detailService.refreshPartApprovalMatrix();
            this.detailService.refreshWorkApprovalMatrix();
          });
      }

    }

  }


  /**
   * 
   */
  isOnHold = () => {
    return this.request && (
      this.request.RequestStatus === ApprovalStatus.ONHOLD
    );
  }


  /**
   * 
   */
  isReadOnly = (): boolean => {
    return !this.isPteTm || this.request && (
      this.request.RequestStatus === ApprovalStatus.CANCELLED ||
      this.request.RequestStatus === ApprovalStatus.COMPLETE
    );
  }


  /**
   * 
   */
  isCancelDisabled = (): boolean => !this.request || !this.request.IsCancelEnabled;


  /**
   * 
   */
  isReworkDisabled = (): boolean => !this.request || !this.request.IsReworkRequestEnabled;


  /**
   * 
   */
  isCopyDisabled = (): boolean => !this.request || !this.request.IsCopyEnabled;


  /**
   * 
   */
  isOnHoldDisabled = (): boolean => !this.request || (!this.request.IsOnHoldEnabled && !this.request.IsRemoveOnHoldEnabled);

  /**
   * 
   */
  isPrintDisabled = (): boolean => this.detailService.requestService.loading.value || this.partApprovalMatrix.loading.value || this.workApprovalMatrix.loading.value;


  /**
   * 
   */
  getButtonTitle() {
    if (this.request && this.request.RequestStatus === ApprovalStatus.ONHOLD) {
      return 'Resume';
    }
    else {
      return 'Hold';
    }
  }


  /**
   * 
   */
  viewRequestDetail = (requestNumber) => {
    this.router.navigate(['/CTWR/Detail', requestNumber]);
  }

  /**
   * 
   */
  setTemporaryRequests() {
    let requests: string[] = [];
    if (this.detailService.requestDetail.value.RefRequests) {
      requests = this.detailService.requestDetail.value.RefRequests
        .split(',')
        .map(t => t.trim());
    }
    this.temporaryRequests = requests;
  }


  /**
   * 
   */
  printPage() {
    let printContents, popupWin;
    printContents = document.getElementById('detailPrintview').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Request Detail</title>
          <style>
          body {
            font-family: Roboto, 'Segoe UI', Tahoma, sans-serif;
          }
          table {
            font-size: 14px;
            border-collapse: collapse;
            width: 100%;
            border: 0px;
            cellpadding: 0px; 
            cellspacing: 0px;
          }
          thead {
            display:table-header-group;
          }
          td, th {
            border: 0.5px solid #dddddd;
            text-align: left;
            padding: 8px;
          }
          tr:nth-child(odd) {
            background-color: #e6e6e6;
          }

          .k-grid-aria-root table{
            table-layout:fixed;
            width: 750px;
          }
 
          .stretch {
              width: 100%;
              display: flex;
              flex: 1 1 auto;
          }
              
          .detail-container {
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
          }  
          .inline-flex {
              display: inline-flex;
              width: 100%;
          }  
          .flex-wrap {
              flex-wrap: wrap;
          }
          .item {
              line-height: 1.65em;
              white-space: nowrap;
              display: inline-flex;
              width: 380px;
          }

.item>span {
    font-size: 0.875em;
    margin-right: 5px;
}

          .page-break { page-break-before: always; } 
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  /**
   * 
   * @param message 
   */
  displaySnackbar(message: string) {
    this.cgpSnackbar.showSnackbar({
      message,
      duration: 2000
    });
  }
}

const RequestSteps = ['New', 'Part Approval', 'Location Approval', 'Work Approval', 'Completed'];
